const SAFE_URL = /^(https?:\/\/|mailto:|\/)/i;

function inline(text, keyBase) {
  const out = [];
  const re = /(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(\[([^\]]+)\]\(([^)\s]+)\))/g;
  let last = 0, m, i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const k = `${keyBase}-${i++}`;
    if (m[2]) out.push(<strong key={k}>{m[2]}</strong>);
    else if (m[4]) out.push(<em key={k}>{m[4]}</em>);
    else if (SAFE_URL.test(m[7])) {
      const ext = /^https?:/i.test(m[7]);
      out.push(<a key={k} href={m[7]} style={{ color: "var(--gold)", textDecoration: "underline" }} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{m[6]}</a>);
    } else out.push(m[6]);
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

const textStyle = { color: "var(--warm-gray)", lineHeight: 1.85, fontSize: "1.02rem" };

export function renderMarkdown(md = "") {
  return md.replace(/\r/g, "").split(/\n\s*\n/).map((block, i) => {
    const lines = block.split("\n").filter((l) => l.trim() !== "");
    if (!lines.length) return null;
    const h = lines[0].match(/^(#{1,3})\s+(.*)$/);
    if (h && lines.length === 1) {
      const level = h[1].length + 1;
      const Tag = `h${level}`;
      const size = level === 2 ? "1.7rem" : level === 3 ? "1.35rem" : "1.15rem";
      return <Tag key={i} style={{ fontFamily: "var(--serif)", fontWeight: 400, fontSize: size, color: "var(--charcoal)", margin: "40px 0 14px", lineHeight: 1.25 }}>{inline(h[2], i)}</Tag>;
    }
    if (lines.every((l) => /^\s*[-*]\s+/.test(l))) {
      return <ul key={i} style={{ paddingLeft: 22, margin: "0 0 20px", listStyle: "disc" }}>{lines.map((l, j) => <li key={j} style={{ ...textStyle, marginBottom: 6 }}>{inline(l.replace(/^\s*[-*]\s+/, ""), `${i}-${j}`)}</li>)}</ul>;
    }
    if (lines.every((l) => /^\s*\d+\.\s+/.test(l))) {
      return <ol key={i} style={{ paddingLeft: 22, margin: "0 0 20px", listStyle: "decimal" }}>{lines.map((l, j) => <li key={j} style={{ ...textStyle, marginBottom: 6 }}>{inline(l.replace(/^\s*\d+\.\s+/, ""), `${i}-${j}`)}</li>)}</ol>;
    }
    return <p key={i} style={{ ...textStyle, margin: "0 0 20px" }}>{lines.map((l, j) => <span key={j}>{inline(l, `${i}-${j}`)}{j < lines.length - 1 && <br />}</span>)}</p>;
  });
}

export function formatPostDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
}
